<template>

  <div>
    <div class="section">
      <div class="columns">

        <main class="column">
          <AppHeader></AppHeader>
          <div class="level">
            <article class="message">
              <div class="message-body">
                <div class="title is-5">The history of British investigative journalism, 1800-2020 as timeline</div>
                <div class="text">
                  Below is a sample interactive timeline of significant events in the history of British investigative journalism, 1800-2020, that is currently under development. The (draft) document we are using to populate/develop this section may be found <a href="https://drive.google.com/file/d/1SB4ohYJj08JSxv9XYlnVBWqTNe2B3t_e/view" target="blank">here</a>.
                </div>
              </div>
            </article>
          </div>

          <div class="level">
                <div id="timeline">
                  <GChart
                    :settings="{ packages: ['corechart', 'timeline'] }"
                    type="Timeline"
                    :data="chartData"
                    :options="chartOptions"
                    style="width: 1200px; height: 400px;"
                    @ready="onChartReady"
                    ref="gChart"
                  />
                </div>
          </div>

          <div class="level">
            <button type="button" class="button" v-on:click="onHomeClick()" >Home</button>
          </div>

          <AppFooter></AppFooter>

      </main>
    </div>
  </div>
  </div>

</template>

<script>

    import { GChart } from "vue-google-charts";
    import AppHeader from "./AppHeader";
    import AppFooter from "./AppFooter";

    export default {
        name: "TimelineChart",
        components: {
            AppFooter,
            GChart,
            AppHeader
        },
        data() {
            return {
                chartData: null,
                chartOptions: {
                    timeline: { showRowLabels: true },
                    hAxis: {
                        title: '',
                        viewWindow:{ min: new Date(1999, 1, 1 ),
                            max: new Date(2020, 1, 1 )},
                        gridlines: {color: '#FFFFFF'},
                        backgroundColor: '#ffd'
                    },
                    width:1200,
                    height:600,
                    colors: ['#D6F1FF','#9ae2ff', '#42C0FB','#D6F1FF','#9ae2ff', '#42C0FB','#D6F1FF','#9ae2ff', '#42C0FB','#D6F1FF','#9ae2ff'],
                }
            };
        },
        methods: {
            onChartReady(chart, google) {
                // now we have google lib loaded. Let's create data table based using it.
                this.createDataTable(chart, google);
            },
            // Array will be automatically processed with visualization.arrayToDataTable function
            createDataTable(chart, google) {

                var container = document.getElementById('timeline');
                var chart = new google.visualization.Timeline(container);

                var dataTable = new google.visualization.DataTable();
             //   dataTable.addColumn({ type: 'string', id: 'Id' });
                dataTable.addColumn({ type: 'string', id: 'Name' });
                dataTable.addColumn({ type: 'date', id: 'Start' });
                dataTable.addColumn({ type: 'date', id: 'End' });
                dataTable.addRows([
                    [  'Tonight - ITV', new Date(1999, 10, 30), new Date(2020, 1, 1) ],
                    [  'MacIntyre Undercover/Investigates ', new Date(1999, 2, 4),  new Date(2003, 1, 1) ],
                    [  'Unreported World - Channel 4',  new Date(2000, 1, 28),  new Date(2020, 1, 1) ],
                    [  'Inside Out - BBC',  new Date(2002, 3, 10),  new Date(2020, 1, 1) ],
                    [  'Centre for Investigative Journalism launched',  new Date(2003, 1, 7),  new Date(2009, 1, 1) ],
                    [  'Bureau of Investigative Journalism launched',  new Date(2009, 4, 7),  new Date(2010, 4, 12) ],
                    [  'Al Jazera\'s Africa Investigates Strand',  new Date(2011, 4, 7),  new Date(2020, 1, 1) ],
                    [  'Exposure - ITV',  new Date(2011, 4, 7),  new Date(2020, 1, 1) ],
                    [  'Bellingcat launched',  new Date(2014, 4, 7),  new Date(2020, 1, 1) ],
                    [  'Buzzfeed develops international "investigative" unit, including London team',  new Date(2011, 4, 7),  new Date(2020, 1, 1) ],
                   ]);

               chart.draw(dataTable, this.chartOptions);

            },
            onHomeClick() {
              this.$router.push('/').catch(error => {});
            }
        }
    }
</script>

<style scoped>

  #timeline {
    height: 600px;
    width: 1200px;
  }

  #text {
    padding: 20px 0;
  }

</style>
